import React from "react";
import { colors } from "../../config/colors";

const ToggleSwitch = ({ isChecked, handleToggle }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      onClick={handleToggle}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#166473]/20 focus:ring-offset-2 ${
        isChecked ? "bg-[#166473]" : "bg-[#87b1b9]"
      }`}
    >
      <span
        className={`${
          isChecked ? "translate-x-4" : "translate-x-1"
        } inline-block h-3 w-3 transform rounded-full bg-white transition-transform`}
      />
    </button>
  );
};

export default ToggleSwitch;
